const readRawSlug = (value) => {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    return String(value.partner_slug ?? value.slug ?? value.value ?? value.id ?? '');
  }
  return '';
};

export const normalizePartnerSlug = (value) =>
  readRawSlug(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getPartnerLoginPath = () => '/partner/login';

export const getPartnerInquiryPath = () => '/contact#contact_form_partners';

export const getPartnerRegisterPath = () => getPartnerInquiryPath();

const ensureSlug = (slug) => normalizePartnerSlug(slug || '');

export const getPartnerAdminPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/admin`;
};

export const getPartnerAdminExcursionsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/admin/excursions`;
};

export const getPartnerAdminCarsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/admin/cars`;
};

export const getPartnerAdminSellersPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/admin/sellers`;
};

export const getPartnerAdminHotelsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/admin/hotels`;
};

export const getPartnerUserPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/user`;
};

export const getPartnerUserExcursionsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/user/excursions`;
};

export const getPartnerUserCarsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/user/cars`;
};

export const getPartnerUserHotelsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return getPartnerLoginPath();
  return `/partner/${encodeURIComponent(safeSlug)}/user/hotels`;
};

export const getPartnerExcursionsPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return '/excursions';
  return `/partner/${encodeURIComponent(safeSlug)}/excursions`;
};

export const getPartnerCarRentalPath = (slug) => {
  const safeSlug = ensureSlug(slug);
  if (!safeSlug) return '/car-rental';
  return `/partner/${encodeURIComponent(safeSlug)}/car-rental`;
};

export const getPartnerPortalPathForRole = (slug, role) =>
  role === 'partner_admin' ? getPartnerAdminPath(slug) : getPartnerUserPath(slug);
